
import { useParams, Link } from 'react-router-dom';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import WhatsAppButton from '../../../components/feature/WhatsAppButton';
import Button from '../../../components/base/Button';

export default function ProductDetail() {
  const { id } = useParams();
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('overview');
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);

  const getProductData = () => {
    const currentLang = localStorage.getItem('i18nextLng') || 'fa';
    
    if (currentLang === 'en') {
      return {
        id: 4,
        name: 'Anti-Thrips net',
        category: 'protection',
        price: '$12',
        originalPrice: '$15',
        images: [
          'https://public.readdy.ai/ai/img_res/a856524b39bf3933b2d79afafb978dbe.jpg',
          'https://readdy.ai/api/search-image?query=anti-thrips%20mesh%20installation%20in%20greenhouse%20covering%20plants%20protective%20netting%20agricultural%20application%20professional%20setup&width=600&height=600&seq=thrips-detail2&orientation=squarish',
          'https://readdy.ai/api/search-image?query=close%20up%20view%20of%20anti-thrips%20mesh%20texture%20showing%20fine%20weave%20pattern%20protective%20agricultural%20netting%20material%20detail&width=600&height=600&seq=thrips-detail3&orientation=squarish',
          'https://readdy.ai/api/search-image?query=anti-thrips%20net%20roll%20packaging%20professional%20agricultural%20product%20white%20background%20industrial%20photography&width=600&height=600&seq=thrips-detail4&orientation=squarish'
        ],
        shortDescription: 'Protective screen against harmful greenhouse insects',
        fullDescription: 'Our Anti-Thrips net is a high-quality protective mesh designed specifically for greenhouse applications. Made from durable polyethylene material, this fine mesh provides excellent protection against thrips and other small insects while maintaining optimal air circulation and light transmission for healthy plant growth.',
        features: [
          'Thrips Protection',
          'Good Ventilation', 
          'Light Transmission',
          'UV Resistant',
          'Easy Installation',
          'Durable Material',
          'Weather Resistant',
          'Reusable'
        ],
        specifications: {
          'Dimensions': '2×10 meters',
          'Mesh Size': '0.15×0.35 mm',
          'Color': 'White',
          'Material': 'Polyethylene',
          'UV Protection': 'Yes',
          'Weight': '150 g/m²',
          'Temperature Range': '-20°C to +80°C',
          'Warranty': '2 years'
        },
        applications: [
          'Greenhouse protection',
          'Nursery coverage',
          'Crop protection',
          'Ventilation systems',
          'Screen houses',
          'Agricultural tunnels'
        ],
        installation: [
          'Clean the installation area thoroughly',
          'Measure and cut the mesh to required size',
          'Secure the mesh using clips or fasteners',
          'Ensure proper tension for optimal performance',
          'Check for any gaps or loose areas',
          'Regular maintenance and cleaning'
        ],
        benefits: [
          'Reduces pest damage by up to 95%',
          'Maintains natural ventilation',
          'Allows 85% light transmission',
          'Extends crop growing season',
          'Reduces pesticide usage',
          'Improves crop quality and yield'
        ],
        inStock: true,
        stockQuantity: 50,
        rating: 4.8,
        reviewCount: 24
      };
    } else if (currentLang === 'ar') {
      return {
        id: 4,
        name: 'شبكة مكافحة التريبس',
        category: 'protection',
        price: '120,000 ريال',
        originalPrice: '150,000 ريال',
        images: [
          'https://readdy.ai/api/search-image?query=anti-thrips%20insect%20screen%20mesh%20for%20greenhouse%20protection%20fine%20mesh%20agricultural%20netting%20white%20background%20professional%20product%20photography%20detailed%20texture%20close%20up%20view&width=600&height=600&seq=thrips-detail1&orientation=squarish',
          'https://readdy.ai/api/search-image?query=anti-thrips%20mesh%20installation%20in%20greenhouse%20covering%20plants%20protective%20netting%20agricultural%20application%20professional%20setup&width=600&height=600&seq=thrips-detail2&orientation=squarish',
          'https://readdy.ai/api/search-image?query=close%20up%20view%20of%20anti-thrips%20mesh%20texture%20showing%20fine%20weave%20pattern%20protective%20agricultural%20netting%20material%20detail&width=600&height=600&seq=thrips-detail3&orientation=squarish',
          'https://readdy.ai/api/search-image?query=anti-thrips%20net%20roll%20packaging%20professional%20agricultural%20product%20white%20background%20industrial%20photography&width=600&height=600&seq=thrips-detail4&orientation=squarish'
        ],
        shortDescription: 'شاشة واقية ضد الحشرات الضارة في البيوت المحمية',
        fullDescription: 'شبكة مكافحة التريبس عالية الجودة مصممة خصيصاً لتطبيقات البيوت المحمية. مصنوعة من مادة البولي إيثيلين المتينة، توفر هذه الشبكة الدقيقة حماية ممتازة ضد التريبس والحشرات الصغيرة الأخرى مع الحفاظ على التهوية المثلى ونقل الضوء لنمو صحي للنباتات.',
        features: [
          'حماية من التريبس',
          'تهوية جيدة',
          'نقل الضوء',
          'مقاوم للأشعة فوق البنفسجية',
          'سهل التركيب',
          'مادة متينة',
          'مقاوم للطقس',
          'قابل للإعادة الاستخدام'
        ],
        specifications: {
          'الأبعاد': '2×10 متر',
          'حجم الشبكة': '0.15×0.35 مم',
          'اللون': 'أبيض',
          'المادة': 'بولي إيثيلين',
          'الحماية من الأشعة فوق البنفسجية': 'نعم',
          'الوزن': '150 جم/م²',
          'نطاق درجة الحرارة': '-20°م إلى +80°م',
          'الضمان': 'سنتان'
        },
        applications: [
          'حماية البيوت المحمية',
          'تغطية المشاتل',
          'حماية المحاصيل',
          'أنظمة التهوية',
          'البيوت الشبكية',
          'الأنفاق الزراعية'
        ],
        installation: [
          'تنظيف منطقة التركيب بدقة',
          'قياس وقطع الشبكة للحجم المطلوب',
          'تثبيت الشبكة باستخدام المشابك أو المثبتات',
          'ضمان التوتر المناسب للأداء الأمثل',
          'فحص أي فجوات أو مناطق مفكوكة',
          'الصيانة والتنظيف المنتظم'
        ],
        benefits: [
          'يقلل أضرار الآفات بنسبة تصل إلى 95%',
          'يحافظ على التهوية الطبيعية',
          'يسمح بنقل 85% من الضوء',
          'يمدد موسم نمو المحاصيل',
          'يقلل استخدام المبيدات',
          'يحسن جودة وإنتاجية المحاصيل'
        ],
        inStock: true,
        stockQuantity: 50,
        rating: 4.8,
        reviewCount: 24
      };
    } else if (currentLang === 'ru') {
      return {
        id: 4,
        name: 'Сетка против трипсов',
        category: 'protection',
        price: '1200 руб',
        originalPrice: '1500 руб',
        images: [
          'https://readdy.ai/api/search-image?query=anti-thrips%20insect%20screen%20mesh%20for%20greenhouse%20protection%20fine%20mesh%20agricultural%20netting%20white%20background%20professional%20product%20photography%20detailed%20texture%20close%20up%20view&width=600&height=600&seq=thrips-detail1&orientation=squarish',
          'https://readdy.ai/api/search-image?query=anti-thrips%20mesh%20installation%20in%20greenhouse%20covering%20plants%20protective%20netting%20agricultural%20application%20professional%20setup&width=600&height=600&seq=thrips-detail2&orientation=squarish',
          'https://readdy.ai/api/search-image?query=close%20up%20view%20of%20anti-thrips%20mesh%20texture%20showing%20fine%20weave%20pattern%20protective%20agricultural%20netting%20material%20detail&width=600&height=600&seq=thrips-detail3&orientation=squarish',
          'https://readdy.ai/api/search-image?query=anti-thrips%20net%20roll%20packaging%20professional%20agricultural%20product%20white%20background%20industrial%20photography&width=600&height=600&seq=thrips-detail4&orientation=squarish'
        ],
        shortDescription: 'Защитная сетка против вредных тепличных насекомых',
        fullDescription: 'Наша сетка против трипсов - это высококачественная защитная сетка, специально разработанная для тепличных применений. Изготовленная из прочного полиэтиленового материала, эта мелкая сетка обеспечивает отличную защиту от трипсов и других мелких насекомых, сохраняя при этом оптимальную циркуляцию воздуха и светопропускание для здорового роста растений.',
        features: [
          'Защита от трипсов',
          'Хорошая вентиляция',
          'Светопропускание',
          'UV-стойкость',
          'Легкая установка',
          'Прочный материал',
          'Погодостойкость',
          'Многоразовое использование'
        ],
        specifications: {
          'Размеры': '2×10 метров',
          'Размер ячейки': '0.15×0.35 мм',
          'Цвет': 'Белый',
          'Материал': 'Полиэтилен',
          'UV защита': 'Да',
          'Вес': '150 г/м²',
          'Температурный диапазон': '-20°C до +80°C',
          'Гарантия': '2 года'
        },
        applications: [
          'Защита теплиц',
          'Покрытие питомников',
          'Защита урожая',
          'Вентиляционные системы',
          'Сетчатые дома',
          'Сельскохозяйственные туннели'
        ],
        installation: [
          'Тщательно очистить место установки',
          'Измерить и разрезать сетку до нужного размера',
          'Закрепить сетку с помощью зажимов или крепежей',
          'Обеспечить правильное натяжение для оптимальной работы',
          'Проверить на наличие зазоров или ослабленных участков',
          'Регулярное обслуживание и очистка'
        ],
        benefits: [
          'Снижает ущерб от вредителей до 95%',
          'Поддерживает естественную вентиляцию',
          'Пропускает 85% света',
          'Продлевает сезон выращивания',
          'Снижает использование пестицидов',
          'Улучшает качество и урожайность'
        ],
        inStock: true,
        stockQuantity: 50,
        rating: 4.8,
        reviewCount: 24
      };
    } else {
      // Persian (default)
      return {
        id: 4,
        name: 'توری ضد تریپس',
        category: 'protection',
        price: '۱۲۰,۰۰۰ تومان',
        originalPrice: '۱۵۰,۰۰۰ تومان',
        images: [
          'https://readdy.ai/api/search-image?query=anti-thrips%20insect%20screen%20mesh%20for%20greenhouse%20protection%20fine%20mesh%20agricultural%20netting%20white%20background%20professional%20product%20photography%20detailed%20texture%20close%20up%20view&width=600&height=600&seq=thrips-detail1&orientation=squarish',
          'https://readdy.ai/api/search-image?query=anti-thrips%20mesh%20installation%20in%20greenhouse%20covering%20plants%20protective%20netting%20agricultural%20product%20white%20background%20industrial%20photography&width=600&height=600&seq=thrips-detail4&orientation=squarish',
          'https://readdy.ai/api/search-image?query=close%20up%20view%20of%20anti-thrips%20mesh%20texture%20showing%20fine%20weave%20pattern%20protective%20agricultural%20netting%20material%20detail&width=600&height=600&seq=thrips-detail3&orientation=squarish',
          'https://readdy.ai/api/search-image?query=anti-thrips%20net%20roll%20packaging%20professional%20agricultural%20product%20white%20background%20industrial%20photography&width=600&height=600&seq=thrips-detail4&orientation=squarish'
        ],
        shortDescription: 'توری محافظ در برابر حشرات مضر گلخانه',
        fullDescription: 'توری ضد تریپس ما یک توری محافظ با کیفیت بالا است که به طور خاص برای کاربردهای گلخانه‌ای طراحی شده است. این توری ریز که از مواد پلی‌اتیلن بادوام ساخته شده، محافظت عالی در برابر تریپس و سایر حشرات کوچک فراهم می‌کند و در عین حال تهویه بهینه و عبور نور را برای رشد سالم گیاهان حفظ می‌کند.',
        features: [
          'محافظت از تریپس',
          'تهویه مناسب',
          'عبور نور',
          'مقاوم در برابر UV',
          'نصب آسان',
          'مواد بادوام',
          'مقاوم در برابر آب و هوا',
          'قابل استفاده مجدد'
        ],
        specifications: {
          'ابعاد': '۲×۱۰ متر',
          'اندازه چشمه': '۰.۱۵×۰.۳۵ میلی‌متر',
          'رنگ': 'سفید',
          'مواد': 'پلی‌اتیلن (PE)',
          'محافظت UV': '۵-۸ درصد',
          'وزن': '۱۵۰ گرم بر متر مربع',
          'محدوده دما': '۲۰- تا ۸۰+ درجه سانتی‌گراد',
          'گارانتی': '۲ سال',
          'مدل چینی - عرض': '۱.۵ / ۲ / ۲.۵ متر',
          'مدل چینی - طول': '۱۰۰ متر',
          'مدل ایتالیایی - عرض': '۱.۸ / ۲.۳ متر',
          'مدل ایتالیایی - طول': '۲۰۰ متر'
        },
        applications: [
          'محافظت گلخانه',
          'پوشش نهالستان',
          'محافظت محصولات',
          'سیستم‌های تهویه',
          'خانه‌های توری',
          'تونل‌های کشاورزی'
        ],
        installation: [
          'منطقه نصب را به طور کامل تمیز کنید',
          'توری را اندازه‌گیری و به اندازه مورد نیاز برش دهید',
          'توری را با استفاده از گیره یا بست محکم کنید',
          'کشش مناسب را برای عملکرد بهینه تضمین کنید',
          'هرگونه شکاف یا نقاط شل را بررسی کنید',
          'نگهداری و تمیزکاری منظم'
        ],
        benefits: [
          'آسیب آفات را تا ۹۵٪ کاهش می‌دهد',
          'تهویه طبیعی را حفظ می‌کند',
          '۸۵٪ نور را عبور می‌دهد',
          'فصل رشد محصول را تمدید می‌کند',
          'استفاده از آفت‌کش را کاهش می‌دهد',
          'کیفیت و عملکرد محصول را بهبود می‌بخشد'
        ],
        inStock: true,
        stockQuantity: 50,
        rating: 4.8,
        reviewCount: 24
      };
    }
  };

  const product = getProductData();

  const tabs = [
    { id: 'overview', name: 'نمای کلی', icon: 'ri-information-line' },
    { id: 'specifications', name: 'مشخصات فنی', icon: 'ri-settings-3-line' },
    { id: 'installation', name: 'نحوه نصب', icon: 'ri-tools-line' },
    { id: 'applications', name: 'کاربردها', icon: 'ri-plant-line' },
    { id: 'benefits', name: 'مزایا', icon: 'ri-award-line' }
  ];

  const relatedProducts = [
    {
      id: 1,
      name: 'کوکوپیت پریمیوم',
      price: '۲۵۰,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=premium%20coconut%20coir%20substrate%20blocks%20for%20greenhouse%20cultivation%20professional%20agricultural%20growing%20medium%20clean%20white%20background%20high%20quality%20product%20photography&width=300&height=200&seq=related1&orientation=landscape'
    },
    {
      id: 2,
      name: 'نخ UV گلخانه',
      price: '۸۵,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=UV%20resistant%20greenhouse%20twine%20rope%20for%20plant%20support%20professional%20agricultural%20equipment%20white%20background%20modern%20product%20photography&width=300&height=200&seq=related2&orientation=landscape'
    },
    {
      id: 3,
      name: 'چسب ترمیم پلاستیک',
      price: '۴۵,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=greenhouse%20plastic%20repair%20tape%20transparent%20adhesive%20tape%20for%20agricultural%20use%20professional%20quality%20white%20background%20product%20photography&width=300&height=200&seq=related3&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Breadcrumb */}
      <section className="py-4 bg-gray-50">
        <div className="container mx-auto px-4 lg:px-8">
          <nav className="flex items-center space-x-2 text-sm">
            <Link to="/" className="text-gray-600 hover:text-emerald-600 cursor-pointer">خانه</Link>
            <i className="ri-arrow-left-s-line text-gray-400"></i>
            <Link to="/products" className="text-gray-600 hover:text-emerald-600 cursor-pointer">محصولات</Link>
            <i className="ri-arrow-left-s-line text-gray-400"></i>
            <span className="text-emerald-600 font-medium">{product.name}</span>
          </nav>
        </div>
      </section>

      {/* Product Detail */}
      <section className="py-12">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Product Images */}
            <div className="space-y-4">
              <div className="relative">
                <img
                  src={product.images[selectedImage]}
                  alt={product.name}
                  className="w-full h-96 object-cover object-top rounded-3xl shadow-lg"
                />
                {!product.inStock && (
                  <div className="absolute inset-0 bg-black/50 rounded-3xl flex items-center justify-center">
                    <span className="bg-red-600 text-white px-6 py-2 rounded-full font-bold">ناموجود</span>
                  </div>
                )}
              </div>
              <div className="grid grid-cols-4 gap-2">
                {product.images.map((image, index) => (
                  <button
                    key={index}
                    onClick={() => setSelectedImage(index)}
                    className={`relative rounded-2xl overflow-hidden cursor-pointer ${
                      selectedImage === index ? 'ring-2 ring-emerald-500' : ''
                    }`}
                  >
                    <img
                      src={image}
                      alt={`${product.name} ${index + 1}`}
                      className="w-full h-20 object-cover object-top"
                    />
                  </button>
                ))}
              </div>
            </div>

            {/* Product Info */}
            <div className="space-y-6">
              <div>
                <h1 className="text-3xl font-bold text-gray-800 mb-2">{product.name}</h1>
                <p className="text-gray-600 text-lg">{product.shortDescription}</p>
              </div>

              {/* Rating */}
              <div className="flex items-center space-x-4">
                <div className="flex items-center">
                  {[...Array(5)].map((_, i) => (
                    <i
                      key={i}
                      className={`ri-star-fill text-lg ${
                        i < Math.floor(product.rating) ? 'text-yellow-400' : 'text-gray-300'
                      }`}
                    ></i>
                  ))}
                  <span className="mr-2 text-gray-600">({product.rating})</span>
                </div>
                <span className="text-gray-500">{product.reviewCount} نظر</span>
              </div>

              {/* Key Features */}
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-3">ویژگی‌های کلیدی</h3>
                <div className="grid grid-cols-2 gap-2">
                  {product.features.slice(0, 6).map((feature, index) => (
                    <div key={index} className="flex items-center space-x-2">
                      <i className="ri-check-line text-emerald-600"></i>
                      <span className="text-gray-700 text-sm">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* مشخصات فنی */}
              <div className="space-y-4">
                <div className="flex justify-between items-center p-4 bg-gray-50 rounded-2xl">
                  <span className="font-medium text-gray-800">جنس</span>
                  <span className="text-gray-600">PE (پلی‌اتیلن)</span>
                </div>
                <div className="flex justify-between items-center p-4 bg-gray-50 rounded-2-xl">
                  <span className="font-medium text-gray-800">محافظت UV</span>
                  <span className="text-gray-600">۵-۸ درصد</span>
                </div>
                <div className="flex justify-between items-center p-4 bg-gray-50 rounded-2xl">
                  <span className="font-medium text-gray-800">مدل چینی</span>
                  <span className="text-gray-600">عرض ۱.۵، ۲، ۲.۵ متر - طول ۱۰۰ متر</span>
                </div>
                <div className="flex justify-between items-center p-4 bg-gray-50 rounded-2xl">
                  <span className="font-medium text-gray-800">مدل ایتالیایی</span>
                  <span className="text-gray-600">عرض ۱.۸، ۲.۳ متر - طول ۲۰۰ متر</span>
                </div>
                <div className="flex justify-between items-center p-4 bg-gray-50 rounded-2xl">
                  <span className="font-medium text-gray-800">کاربری</span>
                  <span className="text-gray-600">محافظت از گیاهان در برابر آفات</span>
                </div>
                <div className="flex justify-between items-center p-4 bg-gray-50 rounded-2xl">
                  <span className="font-medium text-gray-800">مقاومت</span>
                  <span className="text-gray-600">ضد پارگی و مقاوم در برابر شرایط جوی</span>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="space-y-4">
                <div className="flex flex-col sm:flex-row gap-4">
                  <Button size="lg" className="flex-1">
                    <i className="ri-phone-line ml-2"></i>
                    استعلام قیمت
                  </Button>
                  <Button variant="outline" size="lg" className="flex-1">
                    <i className="ri-heart-line ml-2"></i>
                    افزودن به علاقه‌مندی‌ها
                  </Button>
                </div>
              </div>

              {/* Contact Info */}
              <div className="bg-emerald-50 p-6 rounded-3xl">
                <h4 className="font-semibold text-gray-800 mb-3">نیاز به مشاوره دارید؟</h4>
                <p className="text-gray-600 mb-4">کارشناسان ما آماده پاسخگویی به سوالات شما هستند</p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <Button size="sm" className="flex-1">
                    <i className="ri-phone-line ml-2"></i>
                    تماس تلفنی
                  </Button>
                  <Button variant="outline" size="sm" className="flex-1">
                    <i className="ri-message-3-line ml-2"></i>
                    چت آنلاین
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Details Tabs */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4 lg:px-8">
          {/* Tab Navigation */}
          <div className="flex flex-wrap justify-center gap-2 mb-8">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center space-x-2 px-6 py-3 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap ${
                  activeTab === tab.id
                    ? 'bg-emerald-600 text-white'
                    : 'bg-white text-gray-700 hover:bg-emerald-50 border border-gray-200'
                }`}
              >
                <i className={`${tab.icon} text-lg`}></i>
                <span>{tab.name}</span>
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div className="bg-white rounded-3xl p-8 shadow-lg">
            {activeTab === 'overview' && (
              <div className="space-y-6">
                <h3 className="text-2xl font-bold text-gray-800 mb-4">درباره محصول</h3>
                <p className="text-gray-700 leading-relaxed text-lg">{product.fullDescription}</p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
                  <div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-4">ویژگی‌های کلیدی</h4>
                    <div className="space-y-3">
                      {product.features.map((feature, index) => (
                        <div key={index} className="flex items-center space-x-3">
                          <div className="w-6 h-6 bg-emerald-100 rounded-full flex items-center justify-center">
                            <i className="ri-check-line text-emerald-600 text-sm"></i>
                          </div>
                          <span className="text-gray-700">{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  <div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-4">مزایای استفاده</h4>
                    <div className="space-y-3">
                      {product.benefits.slice(0, 4).map((benefit, index) => (
                        <div key={index} className="flex items-start space-x-3">
                          <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mt-0.5">
                            <i className="ri-star-line text-blue-600 text-sm"></i>
                          </div>
                          <span className="text-gray-700">{benefit}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'specifications' && (
              <div className="space-y-6">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">مشخصات فنی</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {Object.entries(product.specifications).map(([key, value]) => (
                    <div key={key} className="flex justify-between items-center p-4 bg-gray-50 rounded-2xl">
                      <span className="font-medium text-gray-800">{key}</span>
                      <span className="text-gray-600">{value}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {activeTab === 'installation' && (
              <div className="space-y-6">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">راهنمای نصب</h3>
                <div className="space-y-4">
                  {product.installation.map((step, index) => (
                    <div key={index} className="flex items-start space-x-4 p-4 bg-gray-50 rounded-2xl">
                      <div className="w-8 h-8 bg-emerald-600 text-white rounded-full flex items-center justify-center font-bold text-sm">
                        {index + 1}
                      </div>
                      <p className="text-gray-700 flex-1">{step}</p>
                    </div>
                  ))}
                </div>
                
                <div className="mt-8 p-6 bg-yellow-50 rounded-3xl border border-yellow-200">
                  <div className="flex items-start space-x-3">
                    <i className="ri-information-line text-yellow-600 text-xl mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-yellow-800 mb-2">نکته مهم</h4>
                      <p className="text-yellow-700">برای نصب صحیح و بهینه، توصیه می‌شود از کارشناسان فنی ما کمک بگیرید. خدمات نصب و راه‌اندازی ما شامل گارانتی کامل می‌باشد.</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'applications' && (
              <div className="space-y-6">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">کاربردها</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {product.applications.map((application, index) => (
                    <div key={index} className="bg-gradient-to-br from-emerald-50 to-blue-50 p-6 rounded-3xl border border-emerald-100">
                      <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
                        <i className="ri-plant-line text-emerald-600 text-xl"></i>
                      </div>
                      <h4 className="font-semibold text-gray-800 mb-2">{application}</h4>
                      <p className="text-gray-600 text-sm">مناسب برای استفاده در {application} با کیفیت و دوام بالا</p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {activeTab === 'benefits' && (
              <div className="space-y-6">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">مزایا و فواید</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {product.benefits.map((benefit, index) => (
                    <div key={index} className="flex items-start space-x-4 p-6 bg-gradient-to-r from-emerald-50 to-green-50 rounded-3xl border border-emerald-100">
                      <div className="w-10 h-10 bg-emerald-600 rounded-full flex items-center justify-center">
                        <i className="ri-check-line text-white text-lg"></i>
                      </div>
                      <div>
                        <p className="text-gray-800 font-medium">{benefit}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Related Products */}
      <section className="py-20">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">محصولات مرتبط</h2>
            <p className="text-gray-600">محصولات دیگری که ممکن است به آن‌ها نیاز داشته باشید</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {relatedProducts.map((relatedProduct) => (
              <div key={relatedProduct.id} className="bg-white rounded-3xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <img
                  src={relatedProduct.image}
                  alt={relatedProduct.name}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-6">
                  <h3 className="text-lg font-bold text-gray-800 mb-2">{relatedProduct.name}</h3>
                  <div className="flex items-center justify-between">
                    <span className="text-emerald-600 font-bold text-lg">{relatedProduct.price}</span>
                    <Button size="sm">
                      مشاهده
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-emerald-600">
        <div className="container mx-auto px-4 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            آماده خرید هستید؟
          </h2>
          <p className="text-emerald-100 text-lg mb-8">
            برای دریافت مشاوره رایگان و استعلام قیمت با ما تماس بگیرید
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" className="bg-white text-emerald-600 hover:bg-gray-100">
              <i className="ri-phone-line ml-2"></i>
              تماس برای مشاوره
            </Button>
            <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-emerald-600">
              <i className="ri-message-3-line ml-2"></i>
              درخواست کاتالوگ
            </Button>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
